import { render } from "./StudentsTrainingDurationView.vue?vue&type=template&id=8398cc10&scoped=true"
import script from "./StudentsTrainingDurationView.vue?vue&type=script&lang=js"
export * from "./StudentsTrainingDurationView.vue?vue&type=script&lang=js"

import "./StudentsTrainingDurationView.vue?vue&type=style&index=0&id=8398cc10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8398cc10"]])

export default __exports__